export const MUTATION_TYPES = {
  TOGGLE_SEARCH: 'toggleSearchMenu',
  CLEAR_ALERTS: 'setClearStudentAlerts',
  TOGGLE_FAST_SEARCH: 'toogleFastSearch',
  SET_IS_NAV_OPEN: 'setIsNavOpen',
  ADD_STUDENT_SEARCHED: 'addStudentSearched',
  SELECTED_STUDENT: 'setSelectedStudent',
  OPEN_SEARCH_STUDENT: 'openSearchStudent',
  SET_IS_SEARCH_STUDENT_OPENED_FROM_OUTSIDE:
    'setIsSearchStudentOpenedFromOutside',
  SET_HIDE_HISTORY_AND_SELECT_STUDENT: 'setHideHistoryAndSelectStudent',
  SET_STUDENT_SEARCH_HISTORY: 'studentSearchHistory',
};

export const ACTION_TYPES = {
  GET_USER_STUDENT_SEARCHED_HISTORY: 'getUserStudentSearchedHistory',
  SET_STUDENT_DETAILS: 'setStudentDetails',
};
